import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Title } from './styles';

const ModuleTitle: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { t } = useTranslation();
    return <Title>{children}</Title>;
};

export default ModuleTitle;
